import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { monthEndAlertConstants } from '../../actions/constant';
import monthEndAlertsService from '../../../services/apiServices/monthEndAlert/monthEndALerts';

const { GET_LIST_OF_MONTH_REQUEST, GET_LIST_OF_MONTH_SUCCESS, GET_LIST_OF_MONTH_FAILURE } =
  monthEndAlertConstants;

function* getListOfMonthEndAlerts(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(monthEndAlertsService.getListOfMonthEndAlerts, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_LIST_OF_MONTH_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_LIST_OF_MONTH_FAILURE, payload: error });
  }
}

function* getListofMonthEndAlertSaga() {
  yield takeEvery(GET_LIST_OF_MONTH_REQUEST, getListOfMonthEndAlerts);
}

export default getListofMonthEndAlertSaga;
